var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"text-right",staticStyle:{"direction":"rtl"}},[_c('v-main',[_c('vue-page-transition',[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }